import { observer } from 'mobx-react';
import { Fragment } from 'react';
import { makeStyles } from '@mui/styles';
import { storeKrunica } from '../store/KrunicaStore';
import Amen from './Amen';

const useStyles = makeStyles((theme) => ({
  opisMolitve: {
    justifyContent: 'space-between',
    marginTop: '0.5rem',
    textAlign: 'center',
    fontSize: '1.4rem',
    [theme.breakpoints.up('sm')]: {
      backgroundColor: '#e9e9e9',
      color: '#093145',
      border: '1px solid #ece7e7',
      width: '50%',
      margin: 'auto',
      fontSize: '2rem',
    },
  },
}));

function MolitvaBlazenogOca() {
  const classes = useStyles();
  const { aktivnaZemlja, trenutnaKrunica } = storeKrunica;
  const { krunice } = aktivnaZemlja;

  return (
    <Fragment>
      <div className={classes.opisMolitve}>
        {krunice.find((k) => k.value === trenutnaKrunica)?.label}
        <div style={{ marginTop: 20 }}>
          {krunice.find((k) => k.value === trenutnaKrunica)?.ref1}
        </div>
        <div style={{ marginTop: 20 }}>
          {krunice.find((k) => k.value === trenutnaKrunica)?.ref2}
        </div>
        <div style={{ marginTop: 20 }}>
          {krunice.find((k) => k.value === trenutnaKrunica)?.ref3}
        </div>
        <div style={{ marginTop: 20 }}>
          {krunice.find((k) => k.value === trenutnaKrunica)?.ref4}
        </div>
        <Amen />
      </div>
    </Fragment>
  );
}

export default observer(MolitvaBlazenogOca);
